import React from 'react';
import { Formik, Field, Form } from 'formik';
import { css } from 'react-emotion';
import { withRouter } from 'react-router';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

const test = css({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 350,
});

const queryPurchaseOrders = gql`
  query purchaseOrders($organizationId: ID!) {
    purchaseOrders(organizationId: $organizationId) {
      id
      organization_id
      props
    }
  }
`;

const createPurchaseOrder = gql`
  mutation createPurchaseOrder(
    $organizationId: ID!
    $props: JSON
  ) {
    createPurchaseOrder(
      organizationId: $organizationId
      props: $props
    ) {
      id
      organization_id
      props
    }
  }
`;

const withMutation = graphql(createPurchaseOrder, {
  props: ({ mutate }) => ({
    createPurchaseOrder: values => {
      return mutate({
        variables: values,
        update: (proxy, { data: { createPurchaseOrder } }) => {
          const data = proxy.readQuery({
            query: queryPurchaseOrders,
            variables: { organizationId: values.organizationId.toString() },
          });
          // debugger;
          proxy.writeQuery({
            query: queryPurchaseOrders,
            variables: { organizationId: values.organizationId.toString() },
            data: {
              purchaseOrders: [...data.purchaseOrders, createPurchaseOrder],
            },
          });
        },
        // TODO: optimisticResponse
      });
    },
  }),
});

@withRouter
@withMutation
class AddPurchaseOrderForm extends React.Component {
  render() {
    const { createPurchaseOrder, closeModal, params: { organizationId } } = this.props;

    return (
      <Formik
        initialValues={{
          payment_type: 'purchase order',
          organizationId,
          description: '',
        }}
        onSubmit={async (
          values,
          {
            setSubmitting,
            setErrors,
            setFieldError /* setValues and other goodies */,
          },
        ) => {
          setSubmitting(true);
          console.log('vals', values);
          await createPurchaseOrder({
            organizationId,
            props: { description: values.description},
          });
          setSubmitting(false);
          if (closeModal) {
            closeModal();
          }
          }
        }

        render={({ values, setFieldValue, isSubmitting }) => (
          <Form className={test}>
            <Field
              label="Purchase Order Details"
              component="textarea"
              name="description"
              elementRef={c => (this._element = c)}
              style={{marginBottom:16, maxWidth:500}}
            />
            <div className="form-group row justify-content-end">
              <button
                className="btn btn-primary"
                type="submit"
                disabled={isSubmitting}
              >
                {!isSubmitting && 'Add Purchase Order'}
                {isSubmitting && (
                  <span>
                    <i className="fa fa-spinner fa-pulse fa-fw" /> Add Purchase Order
                  </span>
                )}
              </button>
            </div>
          </Form>
        )}
      />
    );
  }
}

export default AddPurchaseOrderForm;



// WEBPACK FOOTER //
// ./src/views/Admin/AddPurchaseOrderForm.js